import { gql } from '@apollo/client';
export const DECLINE_INTERVIEW = gql(`
  mutation declineInterview($payload: [sch_rsvp_action_input!]!) {
    sch_rsvp_action(data: $payload) {
      error_count
      success_count
    }
  }
`);
